import { useClientPortalAPI } from "@certn/api";
import { Loader } from "@certn/cascadia-react";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { NoAPIConfiguration } from "../integrations/developer-api/NoAPIConfiguration";

export function AtsIntegrationsRoot() {
  const navigate = useNavigate();
  const { data, isLoading } = useClientPortalAPI(
    "/api/internal/client-portal/public-api/api-configurations/"
  );
  const apiConfigurations = data?.results;

  useEffect(() => {
    if (apiConfigurations && apiConfigurations.length > 0) {
      navigate(
        `/settings/integrations/${apiConfigurations[0].id}/ats-integrations`
      );
    }
  }, [apiConfigurations, navigate]);

  return isLoading ? <Loader /> : <NoAPIConfiguration />;
}
